export { default } from './SWSectionFeatureCard';
